import React, { Component } from 'react'
import { StaticBox, FlowTable } from 'components/basic'
import http from 'API/http'

class IgmpSnoopStatus extends Component {
  constructor (props) {
    super(props)
    this.state = {
      igmpsnooping: null,
      error: false,
      loading: true
    }
  }
  componentDidMount () {
    this.getIGMP(this.props.id)
  }
  componentWillReceiveProps (props) {
    if (props.updated === this.props.updated) return
    this.setState({loading: true})
    this.getIGMP(props.id)
  }
  async getIGMP (id) {
    var [err, res] = await http.get('2.4/tech/access/' + id + '/link/igmpsnooping')
    if (err) return this.setState({error: true, cause: res.cause, loading: false})
    this.setState({igmpsnooping: res.data, loading: false})
  }
  reload () {
    this.setState({loading: true})
    this.getIGMP(this.props.id)
  }
  render () {
    return (
      <StaticBox dataLoading={this.state.loading} title='IGMP-Snooping' icon='globe' buttons={[{ icon: (this.state.loading ? 'fa-refresh fa-spin' : 'fa-refresh'), event: () => this.reload(), disabled: this.state.loading}]}>
        {this.state.igmpsnooping &&
          <pre className='no-overflow mt-10 no-padding'>
            <FlowTable noClass paginatable={10} data={this.state.igmpsnooping.map(snoop => [
              snoop.multicast,
              snoop.timestamp,
              snoop.counter
            ])}>
              <tr>
                <th>Multicast</th>
                <th>Timestamp</th>
                <th>Counter</th>
              </tr>
            </FlowTable>
          </pre>
        }
        {this.state.error &&
          <pre className='table-pre mt-10'>
            <div className='error-wrapper'>
              <span><i className='fa fa-fw fa-exclamation-triangle' /> <b>Error fetching IGMP-Snooping {this.state.error.cause ? '- ' + this.state.error.cause : ''}</b></span>
            </div>
          </pre>
        }
      </StaticBox>
    )
  }
}
export default IgmpSnoopStatus



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/troubleshooting/IgmpSnoopStatus.js